import { render } from "./invoiceAdd.vue?vue&type=template&id=2c51a74e&scoped=true"
import script from "./invoiceAdd.vue?vue&type=script&lang=js"
export * from "./invoiceAdd.vue?vue&type=script&lang=js"

import "./invoiceAdd.vue?vue&type=style&index=0&id=2c51a74e&lang=scss&scoped=true"
import "./invoiceAdd.vue?vue&type=style&index=1&id=2c51a74e&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c51a74e"]])

export default __exports__